export const PRELOAD_SSR_DATA = 'BASE/PRELOAD_SSR_DATA';
export const CLEAR_SSR_DATA = 'BASE/CLEAR_SSR_DATA';

/**
 * Creates an action that preloads the data required for SSR.
 *
 * @param {Object} data  The preloaded data required for SSR.
 *
 * @returns {Object}     The redux action.
 */
export const preloadDataForSSR = (data) => {

	return {
		type: PRELOAD_SSR_DATA,
		data,
	};

};

/**
 * Creates an action that clears the preloaded data required for SSR.
 *
 * @returns {Object}     The redux action.
 */
export const clearDataForSSR = () => {

	return { type: CLEAR_SSR_DATA };

};
